var env = process.env.NODE_ENV;

var loanPath = '';
var pwalletPath = '';
if(env == 'development'){
    loanPath = 'https://api.funpera.xyz/oldcwallet';
    pwalletPath = '/pwallet';
}else{
    loanPath = 'https://api.funpera.xyz/oldcwallet';
    pwalletPath = 'https://api.funpera.xyz/oldpwallet';
}

export default {
    loanPath,
    pwalletPath
}